import { render, staticRenderFns } from "./ListSurgeryElement.vue?vue&type=template&id=d7b37b36&scoped=true&"
import script from "./ListSurgeryElement.vue?vue&type=script&lang=js&"
export * from "./ListSurgeryElement.vue?vue&type=script&lang=js&"
import style0 from "./ListSurgeryElement.vue?vue&type=style&index=0&id=d7b37b36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7b37b36",
  null
  
)

export default component.exports